/*
 * Make elements with the class "sticky", i.e. they will stick to the top of the viewport
 * as long as their container (or parent) is visible.
 *
 * See https://github.com/rgalus/sticky-js
 */
$(function () {

    DECIX.sticky = DECIX.sticky || {};

    DECIX.sticky.init = function () {

        new Sticky(".sticky");

    };

    DECIX.sticky.init();

});

// Compatible implementation of new sticky library

/**
 * Make elements with the class "sticky", i.e. they will stick to the top of the viewport
 * as long as their parent is visible.
 *
 * See http://leafo.net/sticky-kit/
 */
$(function () {

    DECIX.stickykit = DECIX.stickykit || {};

    DECIX.stickykit.init = function () {

        $(".stick_in_parent").stick_in_parent({
            parent: "[data-sticky-parent]",
            bottoming: true,
            inner_scrolling: true
        });

    };

    DECIX.stickykit.destroy = function () {
        $(".stick_in_parent").trigger("sticky_kit:detach");
    };

    DECIX.stickykit.init();

});
